import script from "./RequestUpdateModalForProductDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestUpdateModalForProductDescription.vue?vue&type=script&setup=true&lang=js"

import "./RequestUpdateModalForProductDescription.vue?vue&type=style&index=0&id=6bfda7b6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bfda7b6"]])

export default __exports__